import React, { FC } from "react";
import { PostDataType } from "data/types";
import Card12 from "./Card12";
import hAzul from "images/hojaAzul.png";
import Card13 from "./Card13";

export interface SectionMagazine5Props {
  posts: PostDataType[];
}

const SectionMagazine5: FC<SectionMagazine5Props> = ({ posts }) => {
  return (
    <div className="nc-SectionMagazine5">


      <div className="flex flex-col items-center justify-center ">
        <div className="py-[5px]  ">
          <img
            className="mx-auto h-25 w-20"
            src={hAzul}
            alt=""
          />
        </div>
        <h2 className="text-3xl md:text-4xl font-semibold">
          WELCOME TO OUR BLOG
          <div className="bg-[#19CFD8] w-full h-[1px]" > </div>
        </h2>
        <div className="pt-4 pb-[40px] font-normal text-base text-neutral-500 text-center px-[10px] md:px-[200px]">
          At Paradise Living, we are passionate about real estate, and we're here to provide you with valuable insights, expert advice, and the latest trends in the industry. Our mission is to empower you with the knowledge you need to make informed decisions about buying, selling, renting, or investing in properties.
        </div>
      </div>

      <div className="grid lg:grid-cols-3 gap-6 md:gap-8">
        {posts[0] && <Card12 post={posts[0]} />}
        {posts[1] && <Card12 post={posts[0]} />}
        {posts[2] && <Card12 post={posts[2]} />}
        {posts[3] && <Card12 post={posts[3]} />}
        {posts[4] && <Card12 post={posts[0]} />}
        {posts[5] && <Card12 post={posts[5]} />}

      </div>
    </div>
  );
};

export default SectionMagazine5;
